import { getPropInSafe } from '@seeneco-ui/core/utils';

import {
	IBusinessState,
	createSelector,
	createAsyncSelector
} from '../../../flux';


const selectAsyncSessionContext = createAsyncSelector({
	get: state => state.$business.tenant.context,
	selector: createSelector(
		(state: IBusinessState) => state.$business.tenant.context.item,
		item => item
	),
});

const selectAsyncTenant = createAsyncSelector({
	get: state => state.$business.tenant.tenant,
	selector: createSelector(
		(state: IBusinessState) => state.$business.tenant.tenant.item,
		item => item
	),
});

const selectAsyncTenantAccount = createAsyncSelector({
	get: state => state.$business.tenant.tenantAccount,
	selector: createSelector(
		(state: IBusinessState) => state.$business.tenant.tenantAccount.item,
		item => item
	),
});

const selectAsyncAccessTokens = createAsyncSelector({
	get: state => state.$business.tenant.tokens,
	selector: createSelector(
		(state: IBusinessState) => state.$business.tenant.tokens.item,
		item => item
	),
});

function selectTenantID(state: IBusinessState): number {
	return getPropInSafe(state, s => s.$business.tenant.context.item.SessionTenant.ID, -1);
}

function selectFirstAccessToken(state: IBusinessState): OAuthAccessToken | null {
	return getPropInSafe(state, s => {
		const item = s.$business.tenant.tokens.item;
		return item[item.length - 1];
	}, null);
}

function selectTicketUID(state: IBusinessState): string | null {
	return getPropInSafe(state, s => s.$business.tenant.context.item.SecurityTicket.TicketUID, null);
}

export const tenantSelectorsPack = {
	selectAsyncSessionContext,
	selectAsyncTenant,
	selectAsyncTenantAccount,
	selectAsyncAccessTokens,
	selectTenantID,
	selectFirstAccessToken,
	selectTicketUID,
};
